const { sameWithMultiPath } = require('../utils');
const { DEFAULT_TEXT_BODY_STYLE } = require('../../Shape/AbstractShape/config/defaultStyles');

exports.computeTextDirectionFromTextBodies = textBodies => sameWithMultiPath(textBodies, ['textDirection', 'assignedStyles.textBody.textDirection'], DEFAULT_TEXT_BODY_STYLE.textDirection, { skipUndefined: false });
